import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const FixedLocationInspectionService = {
    get: async () => axios.get(`${API_DESPACHO}/fixed-location-inspection/1`).then(({data}) => data).catch((err) => { throw err }),
    save: async (id, formData) => axios.post(`${API_DESPACHO}/fixed-location-inspection/${id}`, formData).then(({data}) => data).catch((err) => { throw err }),
};

export default FixedLocationInspectionService;
